import script from "./cpxq.vue?vue&type=script&setup=true&lang=js"
export * from "./cpxq.vue?vue&type=script&setup=true&lang=js"

import "./cpxq.vue?vue&type=style&index=0&id=f7828f86&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7828f86"]])

export default __exports__